module.exports = __webpack_public_path__ + "static/media/Sobesice.fbdcc3d4.jpg";